module.exports = __webpack_public_path__ + "static/media/Bar-do-Alto-1.8732ac8d.jpg";